import { lazy, Suspense } from 'react';

import AcademiesSkeleton from './components/AcademiesSkeleton';

const LazyAcademies = lazy(
  () =>
    import(/* webpackChunkName: "user-dashboard-academies" */ './Academies'),
);

const Academies = () => {
  return (
    <Suspense fallback={<AcademiesSkeleton />}>
      <LazyAcademies />
    </Suspense>
  );
};

export default Academies;
